document.addEventListener("DOMContentLoaded", function () {

  const addToCartBtn = document.querySelector(".product-form__submit");
  if (!addToCartBtn) return;

  addToCartBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    const form = addToCartBtn.closest("form");
    if (!form) return;

    // Get main variant ID
    const variantId = Number(form.querySelector("[name='id']")?.value);
    if (!variantId) {
      alert("Please select a variant");
      return;
    }

    // Custom option block
    const block = document.querySelector(".custom_option_block");
    if (!block) return form.submit();

    // Selected color
    const optionLabel = block.querySelector("legend strong")
      ?.textContent.replace(":", "").trim();

    const hiddenInput = document.querySelector(`input[data-custom-prop='${optionLabel}']`);
    const selectedColor = hiddenInput?.value.trim().toLowerCase();

    // Free color list
    const freeValues = (block.dataset.addonFreeValues || "")
      .split(",")
      .map(v => v.trim().toLowerCase());

    // Add-on variant ID
    const addonVariantId = Number(block.dataset.addonVariantId);

    const shouldAddAddon =
      addonVariantId &&
      selectedColor &&
      !freeValues.includes(selectedColor);

    addToCartBtn.classList.add("loading");
    addToCartBtn.disabled = true;

    try {

      // Convert formData to normal object for line item properties
      const formData = new FormData(form);
      const formObject = {};
      formData.forEach((value, key) => {
        if (key.includes("properties")) {
          if (!formObject.properties) formObject.properties = {};
          formObject.properties[key.replace("properties[", "").replace("]", "")] = value;
        } else if (key === "quantity") {
          formObject.quantity = Number(value);
        }
      });

      // ------------------------------------------------------------
      // CASE 1: Add-on NOT required → normal add
      // ------------------------------------------------------------
      if (!shouldAddAddon) {

        const mainPayload = {
          items: [
            {
              id: variantId,
              quantity: formObject.quantity || 1,
              properties: formObject.properties || {}
            }
          ]
        };

        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(mainPayload)
        });

        window.location.href = "/cart";
        return;
      }

      // ------------------------------------------------------------
      // CASE 2: Add-on required → ADD BOTH in SAME request
      // ------------------------------------------------------------
      const nestedPayload = {
        items: [
          {
            id: variantId,
            quantity: formObject.quantity || 1,
            properties: formObject.properties || {}
          },
          {
            id: addonVariantId,
            quantity: formObject.quantity || 1,
            parent_id: variantId,   // ⭐ NESTED ITEM
            properties: {
              "Additional Charges": `${hiddenInput.value} Charges (+$20)`
            }
          }
        ]
      };

      const nestedRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(nestedPayload)
      });

      if (!nestedRes.ok) {
        throw new Error("Nested add failed");
      }

      // Redirect to cart
      window.location.href = "/cart";

    } catch (err) {
      console.error("Cart error:", err);
      alert("Error adding to cart.");
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove("loading");
    }

  });

});